/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box, Text } from "@towersystems/towersystems-design-system";
import Dropdown from "react-dropdown";
import { get, map } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";

const ConfigureComparision = () => {
  const { report, editReport } = useReportBuilder();

  const defaultOptions = [{ value: "none", label: "None" }];

  const options = [
    ...defaultOptions,
    ...map(get(report, "config.measures"), (measure) => ({
      value: measure,
      label: measure,
    })),
    ...map(get(report, "config.dimensions"), (dimension) => ({
      value: dimension,
      label: dimension,
    })),
  ];

  const handleFilterByChange = ({ value }) => {
    let filterBy =
      value === "none"
        ? {
            config: {
              sort: {
                by: null,
                direction: null,
              },
            },
          }
        : {
            config: {
              sort: {
                by: value,
              },
            },
          };
    editReport(filterBy);
  };

  const handleFilterByDirection = ({ value }) => {
    editReport({
      config: {
        sort: {
          direction: value,
        },
      },
    });
  };

  let filterByvalue = get(report, "config.sort.by", "none");

  return (
    <Box>
      <Text size="xsmall">Sort by</Text>
      <Box>
        <Dropdown
          value={filterByvalue}
          onChange={handleFilterByChange}
          options={options}
        />
      </Box>
      {filterByvalue && filterByvalue !== "none" && (
        <Box marginTop="medium">
          <Dropdown
            value={get(report, "config.sort.direction")}
            onChange={handleFilterByDirection}
            options={[
              { value: "desc", label: "Descending order" },
              { value: "asc", label: "Ascending order" },
            ]}
          />
        </Box>
      )}
    </Box>
  );
};

export default connect((state) => ({
  compare: false,
}))(ConfigureComparision);
